module.exports = __webpack_public_path__ + "img/ring_g_l_null_null@2x.9a4036f4.png";